export default {
  setLoading(state, value) {
    state.isLoading = value;
  },
  setData(state, {
    data,
    meta,
  }) {
    state.data = data;
    state.meta = meta;
  },
  setError(state, value) {
    state.hasError = value;
  },
};
